import type { ChangeEvent } from "react";

type TimelineAppearanceProps = {
  value: number;
  onChange: (next: number) => void;
};

/**
 * Внешний вид таймлайна: только высота (px). Цвета piano roll — фиксированные
 * константы `PIANO_ROLL_COLORS` (см. `pianoRollColors.ts`), из настроек убраны.
 */
export const TimelineAppearance = ({ value, onChange }: TimelineAppearanceProps) => {
  const setHeight = (e: ChangeEvent<HTMLInputElement>) => {
    const h = Number(e.target.value);
    onChange(Number.isFinite(h) ? Math.round(h) : value);
  };

  return (
    <div className="settings-section">
      <p className="muted">Внешний вид таймлайна (piano roll).</p>
      <label className="settings-row">
        <span className="settings-row__label">Высота (px)</span>
        <input
          type="number"
          className="settings-row__input"
          min={80}
          max={2000}
          value={value}
          onChange={setHeight}
          aria-label="Высота таймлайна"
        />
      </label>
    </div>
  );
};
